import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { it, en } from 'vuetify/locale'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VNumberInput } from 'vuetify/labs/VNumberInput'

export default createVuetify({
  locale: {
    locale: 'it',
    fallback: 'en',
    messages: { it, en },
  },
  components: {
    VDateInput,
    VNumberInput,
  },
  defaults: {
    VTextField: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCheckbox: { density: 'compact' },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1867c0',
        },
      },
    },
  },
})
